import { useState } from "react";
import {
  Dialog,
  IconButton,
  ListItemIcon,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Delete, Menu, Create } from "@mui/icons-material";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../App/Helpers/callApi";
import {
  deleteFeaturedGroup,
  editFeaturedGroup,
  getFeaturedGroups,
} from "../FeaturedGroupsService";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { basicSort } from "../../../App/Helpers/BasicSort";
import EditGroupModal from "./EditGroupModal";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },

  tableCell: {
    [theme.breakpoints.down("md")]: {
      width: "auto",
    },
    width: "300px",
    color: theme.palette.primary.copy,
  },
}));

export default function FeaturedGroupsTableCell(props) {
  const classes = useStyles(props);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  function deleteGroup() {
    callAPI(
      deleteFeaturedGroup(props.element.id),
      "Group Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedGroups(props.element.clientId).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        response.forEach(
          (row) => (row.featureAdsLength = row.featureAds.length)
        );
        props.setTableData(response);
      });
    });
  }

  async function editGroup(json) {
    callAPI(
      editFeaturedGroup(json),
      "Group Name Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedGroups(props.element.clientId).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        response.forEach(
          (row) => (row.featureAdsLength = row.featureAds.length)
        );
        props.setTableData(response);
      });
    });
  }

  function openDeleteModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  function openEditModal(e) {
    e.preventDefault();
    setEditModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        component={Link}
        to={{
          pathname: "/featuredgroups/featuredgroupsdetailed",
          state: props.element,
        }}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Group">
                <IconButton onClick={(e) => openDeleteModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : column.label === "Edit" ? (
              <Tooltip title="Edit Group Name">
                <IconButton onClick={(e) => openEditModal(e)} size="large">
                  <Create />
                </IconButton>
              </Tooltip>
            ) : column.label === "" ? (
              <ListItemIcon size="large" className={classes.itemIcon}>
                <Menu />
              </ListItemIcon>
            ) : (
              props.element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this group? This will also delete all featured jobs belonging to this group"
          func={() => deleteGroup()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
      <Dialog open={editModal} onClose={() => setEditModal(false)}>
        <EditGroupModal
          openModal={setEditModal}
          groupId={props.element.id}
          groupName={props.element.name}
          func={editGroup}
        />
      </Dialog>
    </>
  );
}
